import * as React from 'react';
import dashboardWrapper from '~/wrappers/dashboard';
import { t } from '~/i18n';
import { Panel } from '@watcherr/ui';
import HealthcareProviderFormContainer from '~/containers/HealthcareProviders/HealthcareProviderForm';

const HealthcareProviderCreatePage = () => (
  <Panel>
    <HealthcareProviderFormContainer />
  </Panel>
);

export default dashboardWrapper(HealthcareProviderCreatePage, t('healthcareProviders.create.title'));
